import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParentItemProviderService } from '@app/shared';
import { DynamicFormService } from '@ntap/common';
import {
  ItemView,
  ItemViewProviderDirective,
  NtapCommonComponent,
  NtapGlobalConstants,
  UIComponents,
  Util,
  log
} from '@ntap/core';
import { tap, combineLatest } from 'rxjs';

@Component({
  selector: 'app-jedinice-inventure-list',
  templateUrl: './jedinice-inventure-list.component.html',
  providers: [DynamicFormService, ParentItemProviderService]
})
export class JediniceInventureListComponent
  extends NtapCommonComponent
  implements OnInit, OnDestroy
{
  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};
  trenutnaVarijabla: string;

  parentItem: any;
  viewNameClass: string;

  @HostBinding('class') get class() {
    return this.viewNameClass;
  }

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ParentItemProviderService,
    protected itemViewProvider: ItemViewProviderDirective<ItemView>
  ) {
    super();
    this.addSubscription(
      this.itemViewProvider.view$
        .pipe(tap((view: any) => (this.viewNameClass = view['name'])))
        .subscribe()
    );
  }

  ngOnInit() {
    this.subscribeToRouteChange();
  }

  toggleVarijablu() {
    this.trenutnaVarijabla =
      this.trenutnaVarijabla === 'rezultat_inventure'
        ? 'lista_tehnickih_jedinica'
        : 'rezultat_inventure';
    this.changeView(this.trenutnaVarijabla, this.parentItem);
  }

  subscribeToRouteChange() {
    log('subscribe to route params');
    this.addSubscription(
      combineLatest([
        this.route.paramMap,
        this.parentItemProvider.parentItem$
      ]).subscribe(([, parentItem]: [params: any, parentItem: any]) => {
        log('param change');
        this.parentItem = parentItem;
        this.changeView('lista_tehnickih_jedinica', parentItem);
      })
    );
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      [Util.getFullAttrName('earhiv.inventurna_lista', 'inventura_id')]:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ]
    };
    this.currentListViewStateFilter = {};
  }
}
